import { RequestStatus } from "../types/common";

export function mapLoad(status: RequestStatus[]) {
    return status.includes("FETCHING");
}
